import { render, staticRenderFns } from "./ViolationDetail.vue?vue&type=template&id=915ef2f8&scoped=true&"
import script from "./ViolationDetail.vue?vue&type=script&lang=js&"
export * from "./ViolationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViolationDetail.vue?vue&type=style&index=0&id=915ef2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915ef2f8",
  null
  
)

export default component.exports